module.exports = ":host {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/thumbnail-video/thumbnail-video.component.css
// module id = ./src/app/commons/thumbnail-video/thumbnail-video.component.css
// module chunks = main